<div class="pb-2 d-flex align-items-center">
	<ng-container *ngIf="data$ | async as data">
		<mat-icon *ngIf="data.hasParent" class="mr-2">folder</mat-icon>
		<mat-icon *ngIf="!data.hasParent" class="mr-2" svgIcon="house"></mat-icon>
		<span class="font-weight-bold">
			{{ data.parentProjectName || 'projectFolderHint.root' | translate }}
		</span>
	</ng-container>
</div>
